export default __webpack_public_path__ + "3uxmC5M-admin.svg";